import $ from 'jquery';
import { smoothscroll } from '../utils/smoothscroll';

const $page = $('.page');
const $body = $('.page__body');
let pageIsTop = true;

$(function () {
    pageScrolled(true);
    $body.on('scroll', pageScrolled);
});

const pageScrolled = (force = false) => {
    if ($body.scrollTop() > 0) {
        pageScrolledHandler(force);
    } else {
        pageTopHandler(force);
    }
};

const pageScrolledHandler = (force = false) => {
    if (pageIsTop === true || force === true) {
        pageIsTop = false;
        $page.addClass('scrolled');
    }
};

const pageTopHandler = (force = false) => {
    if (pageIsTop === false || force === true) {
        pageIsTop = true;
        $page.removeClass('scrolled');
    }
};

jQuery(document).ready(function($) {
    $('a[href^="#"]').bind('click.smoothscroll', function (e) {
        e.preventDefault();
        var hash = '#' + $(this).attr('href').split("#")[1];
        smoothscroll($(hash), 110);
        window.location.hash = hash;
    });
});